import { render, staticRenderFns } from "./GalleryListProfileLayout.vue?vue&type=template&id=babc91b8&scoped=true&"
import script from "./GalleryListProfileLayout.vue?vue&type=script&lang=js&"
export * from "./GalleryListProfileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babc91b8",
  null
  
)

export default component.exports